import repository from '@/repositories/Repository'

const resource = '/store_groups'

export default {
  get(all) {
    return repository.bizoo.get(`${resource}?all=${all}`).then(r => r.data)
  },
}
